import { render, staticRenderFns } from "./ModalRincian.vue?vue&type=template&id=4fe70c12&"
import script from "./ModalRincian.vue?vue&type=script&lang=js&"
export * from "./ModalRincian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports